import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useLoader } from '../../../../../__legacy__/helpers/useLoader';
import { IUserService } from '../../../../../__legacy__/modules/user/user.service';
import { IWorkspacesStore } from '../../../../../__legacy__/modules/workspaces/workspaces.store';
import { ICurrentWorkspaceBl } from '../../CurrentWorkspace.bl';
import { ICurrentWorkspaceStore } from '../../CurrentWorkspace.store';
import { CurrentWorkspaceSelector } from './CurrentWorkspaceSelector';

export const CurrentWorkspaceSelectorContainer = observer((): ReactElement => {
  const bl = useInjection(ICurrentWorkspaceBl.$);
  const userService = useInjection(IUserService.$);
  const workspacesStore = useInjection(IWorkspacesStore.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);

  const { isLoading, withLoaderAsync } = useLoader();

  const handleRefresh = async (): Promise<void> => {
    await withLoaderAsync(async () => await userService.getUserInfoAsync());
  };

  return (
    <CurrentWorkspaceSelector
      currentWorkspace={currentWorkspaceStore.currentWorkspace}
      workspaces={workspacesStore.workspaces}
      isLoading={isLoading}
      onSelected={bl.selectWorkspace}
      onRefresh={handleRefresh}
    />
  );
});
